export const contactsKeys = {
	all: ['crm', 'contacts'],
	byCompany: (crmCompanyId) => ['crm', 'contacts', 'byCompany', crmCompanyId],
};

export const contactsMutationKeys = {
	create: ['crm', 'contacts', 'create'],
	update: ['crm', 'contacts', 'update'],
	delete: ['crm', 'contacts', 'delete'],
};
